import Cookie, { type CookieAttributes } from "js-cookie";

import { ENV } from "@/config/environment";

const prefix = "radar";

const getCookieDomain = (): string => window.location.hostname;

const getCookieName = (key: string) => `${prefix}-${ENV}_${key}`;

export const getCookie = (key: string): string | null =>
  Cookie.get(getCookieName(key)) || null;

export const removeCookie = (
  key: string,
  options: CookieAttributes = {},
): void => {
  const domain = getCookieDomain();

  Cookie.remove(getCookieName(key), { domain, path: "/", ...options });
};

export const setCookie = <V extends string>(
  key: string,
  value: V,
  options: CookieAttributes = {},
): void => {
  const domain = getCookieDomain();

  Cookie.set(getCookieName(key), value, {
    domain,
    path: "/",
    secure: true,
    sameSite: "lax",
    ...options,
  });
};
